import React from 'react';
import { Outlet } from '@tanstack/react-router';
import Header from '../Home/components/Header'; // Adjust path as needed
import Footer from '../Home/components/Footer';

const BlogLayout = () => {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <Header />
      {/* Apply consistent padding/max-width for blog content area */}
      <main className="max-w-5xl mx-auto px-4 sm:px-8 lg:px-16 py-12">
        <Outlet /> {/* Child routes will render here */}
      </main>
      <Footer />
    </div>
  );
};

export default BlogLayout; 